import React, { useState } from "react";
import Modal from "./Modal";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function GalleryInner() {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState("");
  const [modalImageTitle, setModalImageTitle] = useState("");

  // Tüm yurt fotoğrafları
  const allImages = [
    // Tek Kişilik Oda Görselleri
    {
      src: "/assets/img/yurt-fotograf/tek-kisilik/tek-kisilik-kiz-ogrenci-odasi-1-105.jpg",
      category: "singleRoom",
    },
    {
      src: "/assets/img/yurt-fotograf/tek-kisilik/tek-kisilik-kiz-ogrenci-yurt-odasi-1-106.jpg",
      category: "singleRoom",
    },
    {
      src: "/assets/img/yurt-fotograf/tek-kisilik/fatih-kiz-ogrenci-yurdu-1-107.jpg",
      category: "singleRoom",
    },
    {
      src: "/assets/img/yurt-fotograf/tek-kisilik/odalarimizdan-manzara-1-37.jpg",
      category: "singleRoom",
    },
    {
      src: "/assets/img/yurt-fotograf/tek-kisilik/duzenli-kisisel-esyalar-1-38.jpg",
      category: "singleRoom",
    },
    {
      src: "/assets/img/yurt-fotograf/tek-kisilik/odalardaki-wc-ve-lavabolar-1-35.jpg",
      category: "singleRoom",
    },
    // İki Kişilik Oda Görselleri
    {
      src: "/assets/img/2-3-kisilik-yatay/2-3-kisilik-yatay (1).jpeg",
      category: "doubleRoom",
    },
    {
      src: "/assets/img/2-3-kisilik-yatay/2-3-kisilik-yatay (2).jpeg",
      category: "doubleRoom",
    },
    {
      src: "/assets/img/2-3-kisilik/2-3-kisilik-dikey (3).jpeg",
      category: "doubleRoom",
    },
    {
      src: "/assets/img/2-3-kisilik/2-3-kisilik-dikey (4).jpeg",
      category: "doubleRoom",
    },
    {
      src: "/assets/img/yurt-fotograf/2-kisilik/aydinlik-ve-sehir-manzarali-1-31.jpg",
      category: "doubleRoom",
    },
    {
      src: "/assets/img/yurt-fotograf/2-kisilik/odalarimizdan-gorunum-1-23.jpg",
      category: "doubleRoom",
    },
    // 3 Kişilik Oda Görselleri
    {
      src: "/assets/img/2-3-kisilik-yatay/2-3-kisilik-yatay (3).jpeg",
      category: "tripleRoom",
    },
    {
      src: "/assets/img/2-3-kisilik-yatay/2-3-kisilik-yatay (4).jpeg",
      category: "tripleRoom",
    },
    {
      src: "/assets/img/2-3-kisilik/2-3-kisilik-dikey (5).jpeg",
      category: "tripleRoom",
    },
    {
      src: "/assets/img/2-3-kisilik/2-3-kisilik-dikey (6).jpeg",
      category: "tripleRoom",
    },
    {
      src: "/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/10.jpg",
      category: "tripleRoomFront106",
    },
    {
      src: "/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/13.jpg",
      category: "tripleRoomFront106",
    },
    {
      src: "/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/20.jpg",
      category: "tripleRoomFront106",
    },
    {
      src: "/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/26.jpg",
      category: "tripleRoomFront106",
    },
    {
      src: "/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/31.jpg",
      category: "tripleRoomFront106",
    },
    {
      src: "/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/54.jpg",
      category: "tripleRoomFront106",
    },
    {
      src: "/assets/img/yurt-fotograf/3-kisilik-on-108/37.jpg",
      category: "tripleRoomFront108",
    },
    {
      src: "/assets/img/yurt-fotograf/3-kisilik-arka-cephe/29.jpg",
      category: "tripleRoomBack",
    },
    {
      src: "/assets/img/yurt-fotograf/3-kisilik-arka-cephe/34.jpg",
      category: "tripleRoomBack",
    },
    {
      src: "/assets/img/yurt-fotograf/3-kisilik-arka-cephe/44.jpg",
      category: "tripleRoomBack",
    },
    // Sosyal Alanlar
    {
      src: "/assets/img/yurt-fotograf/yemekhane/5.jpg",
      category: "diningHall",
    },
    {
      src: "/assets/img/yurt-fotograf/yemekhane/6.jpg",
      category: "diningHall",
    },
    {
      src: "/assets/img/yurt-fotograf/yemekhane/42.jpg",
      category: "diningHall",
    },
    {
      src: "/assets/img/yurt-fotograf/yemekhane/56.jpg",
      category: "diningHall",
    },
    {
      src: "/assets/img/yurt-fotograf/yemekhane/59.jpg",
      category: "diningHall",
    },
    {
      src: "/assets/img/yurt-fotograf/yemekhane/60.jpg",
      category: "diningHall",
    },
    {
      src: "/assets/img/yurt-fotograf/yemekhane/61.jpg",
      category: "diningHall",
    },
    { src: "/assets/img/yurt-fotograf/teras/7.jpg", category: "terrace" },
    { src: "/assets/img/yurt-fotograf/teras/8.jpg", category: "terrace" },
    { src: "/assets/img/yurt-fotograf/teras/9.jpg", category: "terrace" },
    { src: "/assets/img/yurt-fotograf/teras/38.jpg", category: "terrace" },
    { src: "/assets/img/yurt-fotograf/teras/39.jpg", category: "terrace" },
    { src: "/assets/img/yurt-fotograf/teras/41.jpg", category: "terrace" },
    { src: "/assets/img/yurt-fotograf/etut/1.jpg", category: "studyRoom" },
    { src: "/assets/img/yurt-fotograf/etut/2.jpg", category: "studyRoom" },
    { src: "/assets/img/yurt-fotograf/etut/3.jpg", category: "studyRoom" },
    { src: "/assets/img/yurt-fotograf/banyo/24.jpg", category: "bathroom" },
    { src: "/assets/img/yurt-fotograf/banyo/25.jpg", category: "bathroom" },
    { src: "/assets/img/yurt-fotograf/banyo/45.jpg", category: "bathroom" },
    { src: "/assets/img/yurt-fotograf/banyo/55.jpg", category: "bathroom" },
    { src: "/assets/img/yurt-fotograf/dis-cephe/33.jpg", category: "exterior" },
    { src: "/assets/img/yurt-fotograf/dis-cephe/36.jpg", category: "exterior" },
    { src: "/assets/img/yurt-fotograf/dis-cephe/40.jpg", category: "exterior" },
    { src: "/assets/img/yurt-fotograf/dis-cephe/53.jpg", category: "exterior" },
  ];

  // Görsel için alt ve title metinlerini oluştur
  const getImageAltAndTitle = (image) => {
    const categoryTitle = t(`service.${image.category}.title`);
    const baseTitle = "Haseki Sultan Kız Öğrenci Yurdu";
    return {
      alt: `${baseTitle} - ${categoryTitle}`,
      title: `${baseTitle} - ${categoryTitle}`,
    };
  };

  // Function to open the modal with the selected image
  const openModal = (image, event) => {
    event.preventDefault();
    const imageInfo = getImageAltAndTitle(image);
    setModalImage(image.src);
    setModalImageTitle(imageInfo.title);
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };
  return (
    <div className="overflow-hidden space" id="gallery-sec">
      <div className="container-fuild">
        <div className="title-area mb-30 text-center">
          <span className="sub-title">{t("nav.generalPhotos")}</span>
          <h2 className="sec-title">{t("service.generalPhotos.title")}</h2>
        </div>
        <div className="row gy-4 gallery-row4">
          {allImages.map((image, index) => {
            const imageInfo = getImageAltAndTitle(image);
            return (
              <div key={index} className="col-auto">
                <div className="gallery-box style5">
                  <div className="gallery-img global-img">
                    <img
                      src={image.src}
                      alt={imageInfo.alt}
                      title={imageInfo.title}
                    />
                    <Link
                      to={image.src}
                      className="icon-btn popup-image"
                      onClick={(e) => openModal(image, e)}
                    >
                      <i className="fal fa-magnifying-glass-plus" />
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        closeModal={closeModal}
        imageSrc={modalImage}
        imageTitle={modalImageTitle}
      />
    </div>
  );
}

export default GalleryInner;
